<template>
  <container fluid class="px-15">
    <h1 class="ml-14 mt-7 text-h4 font-weight-bold titleText--text">
      Projects
    </h1>
    <v-col cols="12" class="d-flex justify-start">
      <v-col cols="12">
        <v-text-field
          class="mx-8 table-container mb-5"
          style="border-radius: 8px; border: 2px solid #f3f5f8"
          dense
          color="titleText"
          solo
          flat
          hide-details="auto"
          full-width
          placeholder="Type any character ..."
          v-model="filter"
        />
        <div
          class="table-container mr-5"
          role="table"
          aria-label="Destinations"
        >
          <div class="d-flex justify-start pl-5" role="rowgroup">
            <div
              class="flex-row header"
              role="columnheader"
              v-for="title in headers"
              :key="title.text"
              :style="{ width: title.text.length ? '18.8%' : '1%' }"
            >
              {{ title.text }}
            </div>
          </div>
          <v-card
            v-for="item in filteredItems"
            @click="goTo(item.id, item.name, item.current_step)"
            class="
              d-flex
              justify-start
              row
              mb-2
              py-4
              pl-8
              custom-shadow
              cursor__pointer
            "
            role="rowgroup"
            :key="item.name"
            min-height="54"
            elevation="0"
            :ripple="false"
          >
            <div class="cell first">{{ item.name }}</div>
            <div
              class="cell second"
              :class="
                item.status === 'Completed' ? 'green--text' : 'orange--text'
              "
            >
              {{ item.status }}
            </div>
            <div class="cell">{{ item.brand }}</div>
            <div class="cell">{{ item.country }}</div>
            <div class="cell">{{ item.level }}</div>
            <div class="cell last">
              <v-btn
                v-if="item.isAddnew"
                small
                icon
                @click.stop="assignUser(item.id, item.name)"
                title="Edit the Project Team"
              >
                <v-icon color="titleText">mdi-account-outline</v-icon>
              </v-btn>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-dialog v-model="usersDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <h2 class="titleText--text font-weight-bold">User Settings</h2>
            <v-spacer />
            <v-btn icon @click="usersDialog = false">
              <v-icon color="titleText">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-simple-table fixed-header dense sortable="true">
              <template v-slot:default>
                <tbody v-if="userCount === 1">
                  <tr v-for="(item, index) in users" :key="index">
                    <td
                      class="text-start titleText--text font-weight-bold"
                      style="font-size: 16px"
                    >
                      {{ item.username }}
                    </td>
                    <td
                      class="text-start titleText--text"
                      style="font-size: 16px"
                    >
                      {{ item.loginid }}
                    </td>
                    <td class="text-end">
                      <v-checkbox
                        color="#2CD8C5"
                        v-model="item.IsMapp"
                        @change="
                          mapuserindb(
                            $event,
                            item.id,
                            item.rowid,
                            item.recordid
                          )
                        "
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col>
      <v-container>
        <v-dialog v-model="projectDialog" persistent max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              fab
              bottom
              right
              dark
              fixed
              color="blue"
              class="mb-10"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>

          <v-card flat>
            <v-card-title class="titleText--text font-weight-bold">
              New Project
              <v-spacer />
              <v-btn icon @click="closeFormProject()">
                <v-icon color="titleText">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="mt-5 text-field__color">
              <v-text-field
                v-model="projectName"
                :counter="50"
                solo
                flat
                hide-details="auto"
                background-color="#F3F5F8"
                placeholder="Type Project Name"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="mr-2">
              <v-spacer />
              <v-btn
                color="blue"
                :disabled="!projectName"
                depressed
                width="100"
                @click="AddNewProject()"
              >
                <span
                  class="font-weight-bold text-capitalize"
                  :class="projectName ? 'white--text' : 'titleText--text'"
                  >Create</span
                >
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-col>
    <v-pagination
      v-if="!filter && ItemListProject.length > amountOfRecordsPerPage"
      v-model="page"
      :length="Math.ceil(ItemListProject.length / amountOfRecordsPerPage)"
      color="blue"
    ></v-pagination>
  </container>
</template>

  <script>
import API from "../api";
import SetupAPI from '@/modules/UploadData/api'
import globalStorage from "../../../global/GlobalStrorage";
export default {
  data: () => ({
    ItemListProject: [],
    page: 1,
    amountOfRecordsPerPage: 5,
    itemCount: 0,
    usersDialog: false,
    users: [],
    userCount: 0,
    dialog: false,
    projectId: null,
    filter: "",
    projectDialog: 0,
    projectName: null,
    canShare: 0,
    filteredItems: [],
  }),
  computed: {
    headers() {
      return [
        {
          text: "Project",
          filterable: true,
          value: "name",
          width: 250,
        },
        {
          text: "Status",
          filterable: true,
          value: "status",
          width: 250,
        },
        {
          text: "Brand",
          filterable: true,
          value: "brand",
          width: 250,
        },
        {
          text: "Country",
          filterable: true,
          value: "country",
          width: 250,
        },
        {
          text: "Level",
          filterable: true,
          value: "level",
          width: 250,
        },
        {
          text: "",
          filterable: true,
          value: "userAdd",
          width: 250,
        },
      ];
    },
  },
  methods: {
    getProject() {
      let tempList = [];
      this.ItemListProject = [];
      this.filteredItems = [];
      API.getprojectlistbyuserid()
        .then((res) => {
          if (res.data.status == -1) {
            // TODO: Make a notification system for handling errors
          } else {
            tempList = res.data;
            for (var k = 0; k < tempList.length; k++) {
              if (
                parseInt(globalStorage.getloginuserid()) ==
                parseInt(tempList[k].ownerid)
              ) {
                tempList[k].isAddnew = 1;
              } else {
                tempList[k].isAddnew = 0;
              }
            }
            this.ItemListProject = tempList;
            this.filteredItems = tempList.sort((a, b) =>
              a.id < b.id ? 1 : -1
            );

            this.filteredItems = !this.ItemListProject.slice(this.ItemListProject.length % this.amountOfRecordsPerPage).length 
            ? this.ItemListProject 
            : this.ItemListProject

            if (this.ItemListProject.length > 0) {
              this.itemCount = 1;
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    goTo(id, name, step) {
      globalStorage.setProjectID(id);
      globalStorage.setProjectName(name);
      globalStorage.setcurrentstep(step);
      this.ActionAfterUpdateprojectStatus(step);
    },
    UpdateProjectReOpen(varcurrentstep, projid) {
      //alert(varcurrentstep);
      API.api_Change_project_completeToWIP(projid)
        .then((res) => {
          alert(JSON.stringify(res));

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.ActionAfterUpdateprojectStatus(varcurrentstep);
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    ActionAfterUpdateprojectStatus(currentstep) {
      SetupAPI.gettheParameterByProjectStep().then((res) => {localStorage.setItem('currency', res.data.currency)})
      let inttempcueent = parseInt(currentstep);
      switch (inttempcueent) {
        case 0:
          this.$router.push("/settingproject");
          break;
        case 1:
          this.$router.push("/settingproject");
          break;
        case 2:
          this.$router.push("/edaprocess");
          break;
        case 3:
          this.$router.push("/dataprocess");
          break;
        case 4:
          this.$router.push("/dataprocess");
          break;
        case 5:
          this.$router.push("/dataprocess");
          break;
        case 6:
          this.$router.push("/modeldataprocess");
          break;
       
        default:
          this.$router.push("/dashboard");
      }
    },
    showAddNewAlertConfirm() {
      this.$swal({
        title: "Are you sure?",
        text: "You want to create a new Project!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes,!",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          globalStorage.RemoveProjectfromStorage();
          this.currentstep = 0;
          this.projectDialog = 1;
        }
      });
    },
    assignUser(id) {
      this.handleAssignUser(id);
    },
    handleAssignUser(projectid) {
      API.getuserbyid()
        .then((res) => {
          let userdata = res.data.userlist[0];

          this.canShare = userdata.IsGuest;

          if (this.canShare == 1) {
            this.projectId = projectid;
            this.getteamlistbyproject(projectid);
          }
        })
        .then((this.usersDialog = true))
        .catch(function (error) {
          console.warn(error);
        });
    },

    getteamlistbyproject(projectid) {
      let tempList = [];
      this.users = [];
      API.getteamlist_byproject(projectid, globalStorage.getloginuserid())
        .then((res) => {
          tempList = res.data;
          let rowid = 1;
          for (var k = 0; k < tempList.length; k++) {
            tempList[k].rowid = rowid;
            rowid = rowid + 1;
          }
          this.users = tempList;
          if (this.users.length > 0) {
            this.userCount = 1;
            this.dialog = 1;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    mapuserindb(event, mapuserid, rowid, recordid) {
      if (recordid != 0) {
        if (event) {
          this.RemapUsermapping(mapuserid, rowid);
        } else {
          this.RemoveUsermapping(mapuserid, rowid);
        }
      } else {
        this.AddUsermapping(mapuserid, rowid);
      }
    },
    AddUsermapping(mapuserid, rowid) {
      API.project_user_mapping(
        this.projectId,
        mapuserid,
        globalStorage.getloginuserid()
      )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            //   alert(res.message);
          } else {
            for (var k = 0; k < this.users.length; k++) {
              if (this.users[k].rowid == rowid) {
                this.users[k].IsMapp = 1;
              }
            }
            this.getteamlistbyproject(this.projectId);
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    RemoveUsermapping(mapuserid, rowid) {
      API.project_user_mapping_delete(
        this.projectId,
        mapuserid,
        globalStorage.getloginuserid()
      )
        .then((res) => {
          // alert(res.id);
          // alert(res.status);
          if (res.status != 200) {
            //this.countryList = null;
            //   alert(res.message);
          } else {
            // this.getteamlistbyproject(this.projectId);
            for (var k = 0; k < this.users.length; k++) {
              if (this.users[k].rowid == rowid) {
                this.users[k].IsMapp = 0;
              }
            }
            this.getteamlistbyproject(this.projectId);
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    RemapUsermapping(mapuserid, rowid) {
      API.project_user_mapping_remap(
        this.projectId,
        mapuserid,
        globalStorage.getloginuserid()
      )
        .then((res) => {
          // alert(res.id);
          //  alert(res.status);
          if (res.status != 200) {
            //this.countryList = null;
            //   alert(res.message);
          } else {
            // this.getteamlistbyproject(this.projectId);
            for (var k = 0; k < this.users.length; k++) {
              if (this.users[k].rowid == rowid) {
                this.users[k].IsMapp = 0;
              }
            }
            this.getteamlistbyproject(this.projectId);
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    //new project
    closeFormProject() {
      this.projectDialog = 0;
    },
    AddNewProject() {
      API.createNewProject(this.projectName).then((res) => {
        if (res.data.id == "undefined") {
          this.$swal("Sorry");
        } else {
          if (res.data.id > 0) {
            globalStorage.setProjectID(res.data.id);
            globalStorage.setProjectName(this.projectName);
            globalStorage.setcurrentstep(this.currentstep);
            this.$router.push("/settingproject");
          } else {
            this.$swal(JSON.stringify(res.data.name));
          }
        }
      });
    },
  },
  mounted() {
    this.getProject();
  },
  watch: {
    filter(value) {
      if (value) {
        this.filteredItems = this.ItemListProject.filter(
          (item) =>
            item.name.includes(value) ||
            item.brand.includes(value) ||
            item.country.includes(value) ||
            item.level.includes(value) ||
            item.status.includes(value)
        );
      } else {
        this.filteredItems = this.ItemListProject.slice(
          0,
          this.amountOfRecordsPerPage
        );
      }
    },
    page(value) {
      if (value) {
        this.filteredItems =
          value === 1
            ? this.ItemListProject.slice(
                0,
                this.amountOfRecordsPerPage % this.ItemListProject.length
              )
            : this.ItemListProject.slice(
                (value - 1) * this.amountOfRecordsPerPage,
                value * this.amountOfRecordsPerPage
              );
      }
    },
  },
};
</script>

  <style scoped lang="scss">
.cursor__pointer {
  cursor: pointer;
}

.flex-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 20%);
  grid-template-rows: 100% auto;
  transition: 0.5s;
}

.table-container {
  margin-left: 42px;
}

.flex-row {
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
}
.row:first-child {
  color: #505d6f;
}

.cell {
  font-size: 14px;
  font-weight: 500;
  color: #505d6f;
  opacity: 0.6;
  width: 19%;
}

.text-field__color {
  font-weight: 700;
  color: #505d6f;
  opacity: 0.6;
}

.first {
  opacity: 1;
  font-weight: bold;
  opacity: 0.6;
}

.last {
  width: 1% !important;
}

.second {
  opacity: 0.8;
}

.header {
  font-size: 12px;
  font-weight: 500;
  color: #505d6f;
}

.custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
}

.custom-shadow:hover {
  box-shadow: 0px 16px 36px rgba(82, 111, 151, 0.06) !important;
  transform: scale(1.004);
  transition: all 0.2s ease-out;
}

.cursor__pointer {
  cursor: pointer;
}

table td {
  border: none !important;
}
</style>

